import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { usePublicRequestAccountSetupForm } from 'domains/public/components/request-account-setup/utils/usePublicRequestAccountSetup.hooks'
import { Input } from 'gin-and-tonic/common/input/Input'
import { Button } from 'gin-and-tonic/common/button/Button'
import { ErrorMessage } from 'gin-and-tonic/common/error-message/ErrorMessage'
import { PublicLayout } from 'domains/public/components/layout/PublicLayout'
import { DashRedirect } from 'legacy/dash-components/dash-redirect/DashRedirect'

const formStyles = css({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'nowrap',
  width: 240,
  justifyItems: 'flex-start',
})

export const PublicRequestAccountSetup: FunctionComponent = () => {
  const {
    requestAccountSetupSuccess,
    disableFormFields,
    formErrorMessageId,
    emailFieldRef,
    onSubmit,
    emailErrorMessageId,
    reCaptchaElement,
  } = usePublicRequestAccountSetupForm()

  if (requestAccountSetupSuccess) {
    return <DashRedirect push toRoute="public-pending-email-verification" />
  }

  return (
    <PublicLayout headerMessageId="public.requestAccountSetup.header">
      <form css={formStyles} onSubmit={onSubmit}>
        <Input
          name="email"
          disabled={disableFormFields}
          errorMessageId={emailErrorMessageId}
          placeholderMessageId="public.requestAccountSetup.form.fields.email.placeholder"
          ref={emailFieldRef}
          data-testid="public-request-account-setup-form-field-email"
        />

        {reCaptchaElement}

        <ErrorMessage
          messageId={formErrorMessageId}
          data-testid="public-request-account-setup-form-error-message"
        />

        <Button
          disabled={disableFormFields}
          type="submit"
          messageId="public.requestAccountSetup.form.submit"
          data-testid="public-request-account-setup-form-submit"
        />
      </form>
    </PublicLayout>
  )
}
